// extracted by mini-css-extract-plugin
module.exports = {"arrow-back":"styles_arrow-back__1Z_a3"};